<template src="./template.html"></template>
<script>
import Promise from 'bluebird'
import { mapState } from 'vuex'

import membershipService from 'api/membership'
import PaymentProfile from 'components/PaymentProfile'
import config from 'src/config'
import TRACKING_EVENTS from 'constants/trackingEvents'
import analyticsLib from 'lib/analytics'
import eventBus from 'lib/eventBus'

const TERMS_INVALID_ERROR_MSG = 'terms invalid'
const FORM_INVALID_MSG = 'form is invalid'
const CARD_IMCOMPLETE_ERROR_MSG = 'Your card number is incomplete.'

export default {
  name: 'membership-checkout',
  components: {
    PaymentProfile,
  },
  computed: {
    ...mapState({
      loggedIn: (state) => state.auth.loggedIn,
      user: (state) => state.user.current,
      currentPlan: (state) => state.membership.currentPlan,
      currentAffiliate: (state) => state.membership.currentAffiliate,
      //
      attributionId: (state) => state.config.attributionId,
      affiliateId: (state) => state.config.affiliateId,
      trackingId: (state) => state.config.trackingId,
      client: (state) => state.config.client,
    }),
    terms() {
      if (!this.currentPlan) return []

      return [
        this.currentPlan.terms
          .map((term) => {
            return `<p>${term}.</p>`
          })
          .join(' '),
      ]
    },
  },
  data() {
    return {
      termsAndConditionsUrl: config.TERMS_URL,
      currentPaymentProfile: null,
      showPaymentProfileError: false,
      paymentProfileErrorMessage: null,
      membershipForm: {
        acceptedTerms: [],
      },
      showTermsError: false,
      purchasingErrorMessage: null,
      purchasing: false,
      //discount
      showDiscountForm: false,
      discountErrorMessage: false,
      discountApplied: false,
      membershipDiscountForm: {
        promoCode: null,
      },
    }
  },
  methods: {
    changePlan() {
      this.$store.dispatch('setCurrentMembershipPlan', null)

      this.$router.push({
        name: 'MembershipSelectPlan',
      })
    },
    redeemDiscount() {
      this.discountErrorMessage = null
      this.discountApplied = false

      return this.$validator.validateAll('membershipDiscountForm').then((success) => {
        if (success) {
          return membershipService
            .checkout({
              planId: this.currentPlan.id,
              promoCode: this.membershipDiscountForm.promoCode,
            })
            .then((result) => {
              const currentPlan = this.currentPlan

              currentPlan.promoCode = this.membershipDiscountForm.promoCode
              currentPlan.status = result.status
              currentPlan.statusDescription = result.statusDescription
              currentPlan.discounts = result.discounts
              currentPlan.billingIntervalPrice = result.price / result.billingInterval
              currentPlan.billingPrice = result.price

              this.$store.dispatch('setCurrentMembershipPlan', currentPlan)

              this.discountApplied = true
            })
            .catch((err) => {
              this.discountErrorMessage = err.message
            })
        }

        return null
      })
    },
    validateTerms() {
      let complete = true

      this.terms.forEach((term, index) => {
        if (!this.membershipForm.acceptedTerms[index]) {
          complete = false
        }
      })

      this.showTermsError = !complete

      if (this.showTermsError) {
        return Promise.reject(new Error(TERMS_INVALID_ERROR_MSG))
      }

      return Promise.resolve(true)
    },
    completeMembership() {
      if (this.purchasing) return null //prevent double calls

      this.purchasing = true

      return Promise.all([this.validateTerms(), this.$refs.paymentProfile ? this.$refs.paymentProfile.validate() : null])
        .then(() => {
          this.purchasingErrorMessage = null
          this.showPaymentProfileError = false

          return this.$refs.paymentProfile ? this.$refs.paymentProfile.savePaymentProfile() : null
        })
        .then(() => {
          if (!this.currentPaymentProfile) {
            this.showPaymentProfileError = true
            this.purchasing = false
            return Promise.resolve()
          }

          return membershipService.create({
            userId: this.user.id,
            planId: this.currentPlan.id,
            affiliateId: this.affiliateId,
            trackingId: this.trackingId,
            paymentProfileId: this.currentPaymentProfile.id,
            promoCode: this.currentPlan.promoCode,
          })
        })
        .then(() => {
          const trackingEvent = this.currentAffiliate ? `${TRACKING_EVENTS.CompletedMembershipOrder}-${this.affiliateId}` : TRACKING_EVENTS.CompletedMembershipOrder

          analyticsLib.trackEvent(trackingEvent, {
            plan: this.currentPlan.name,
            price: this.currentPlan.price,
          })

          return this.$store.dispatch('getCurrentUser')
        })
        .then(() => {
          this.purchasing = false

          this.$router.push({
            name: 'MembershipSuccess',
          })
        })
        .catch((error) => {
          this.purchasing = false
          this.purchasingErrorMessage = error && (error.message === TERMS_INVALID_ERROR_MSG || error.message === FORM_INVALID_MSG || error.message === CARD_IMCOMPLETE_ERROR_MSG) ? null : error.message
        })
    },
  },
  mounted() {
    if (!this.currentPlan) {
      this.$router.push({
        name: 'MembershipSelectPlan',
      })
    }
  },
  updated() {
    eventBus.$emit('updated')
  },
}
</script>



// WEBPACK FOOTER //
// src/components/MembershipCheckout/index.vue